<template>
  <ul class="nav navbar-nav navbar-right">
    <!-- <router-link to="/cp/inscricao" tag="li"><a>Inscrição</a></router-link> -->
    <!-- <router-link to="/cp/lista-inscritos" tag="li"><a>Lista Inscritos</a></router-link> -->
    <router-link to="/cp/inicio" tag="li"><a>Inicio</a></router-link>
    <router-link to="/cp/chegadas" tag="li"><a>Chegadas</a></router-link>
  </ul>
</template>

<script>
export default {
  name: 'CpNav'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// Nav.vue?53b1e368